var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 30,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeWidth: 1.771,
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9 6.163a4.52 4.52 0 0 1-4.52 4.52h-4.637v-9.04h4.638a4.52 4.52 0 0 1 4.52 4.52ZM1.585 6.163a4.52 4.52 0 0 0 4.52 4.52h4.638v-9.04H6.105a4.52 4.52 0 0 0-4.52 4.52ZM1.585 15.204a4.52 4.52 0 0 0 4.52 4.52h4.638v-9.04H6.105a4.52 4.52 0 0 0-4.52 4.52ZM1.585 24.244c0 2.497 2.053 4.52 4.55 4.52 2.528 0 4.608-2.05 4.608-4.578v-4.462H6.105a4.52 4.52 0 0 0-4.52 4.52ZM10.743 15.204a4.52 4.52 0 0 0 4.52 4.52h.118a4.52 4.52 0 0 0 0-9.04h-.118a4.52 4.52 0 0 0-4.52 4.52Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.646.704H20.84v29H.646z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.a365d743284693bdaf16df37e165cfc6.svg";
export { ForwardRef as ReactComponent };